define((require) => {
    "use strict";

    const Backbone                          = require("backbone"),
        CONSTANTS                           = require("ui/editor/email/Constants"),
        ImprovedView                        = require("editor/zbone/ImprovedView"),
        RemoveIncompatibleWidgetsContentView = require("ui/editor/email/RemoveIncompatibleWidgetsContentView"),
        template                            = require("ui/editor/email/RemoveIncompatibleWidgetsView.tpl"),
        Tooltip                             = require("ui/common/Tooltip");

    const OverlayView = Backbone.View.extend({

        className: "remove-widgets-overlay",

        events: {
            "activate": "_activateHandler"
        },

        render() {
            return this;
        },

        _activateHandler() {
            this.model.set("state", CONSTANTS.CLOSE);
        }

    }, {

        instance: null,

        show(options) {
            const overlayView = new OverlayView(options);
            overlayView.render().$el.appendTo(window.document.body);
            OverlayView.instance = overlayView;
        },

        remove() {
            if (OverlayView.instance) {
                OverlayView.instance.remove();
                OverlayView.instance = null;
            }
        }
    });

    /**
     * Component representing the Send Test Email button for the <tt>SendTestEmailButtonView</tt>.
     *
     *
     * @class RemoveIncompatibleWidgetsView
     *
     */
    return ImprovedView.extend({
        template,

        ui: {
            popup: ".popup"
        },

        initialize() {
            this.__super();
            this.listenTo(this.model, "change:state", this._manageModalState);
        },

        _addPopup(tooltipSettings) {
            Tooltip.add(this.ui.popup, tooltipSettings);
            Tooltip.show(this.ui.popup);
            OverlayView.show({model: this.model});
        },

        _removePopup() {
            Tooltip.remove(this.ui.popup);
            OverlayView.remove();
        },

        _manageModalState() {
            let tooltipSettings = {
                width: 408,
                animation: false,
                trigger: "manual",
                duration: 0,
                classes: "remove-widgets-container email modal-popover"
            };

            switch (this.model.get("state")) {
                case CONSTANTS.CLOSE:
                    this._removePopup();
                    break;

                case CONSTANTS.OPEN:
                    tooltipSettings.content = new RemoveIncompatibleWidgetsContentView({model: this.model});
                    tooltipSettings.html = true;
                    this._addPopup(tooltipSettings);
                    break;

                default:
                    break;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/RemoveIncompatibleWidgetsView.js